import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Navigation, { sectionShape } from '../Navigation';
import Footer from '../Footer';
import './style.css';


const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  sections: PropTypes.arrayOf(sectionShape),
  internalPage: PropTypes.bool,
  onNavLinkClick: PropTypes.func,
};

const defaultProps = {
  children: null,
  sections: [],
  internalPage: false,
  onNavLinkClick: () => {},
};

/**
 * A page layout component including common bits to all pages.
 */
const PageLayout = ({
  children,
  sections,
  internalPage,
  onNavLinkClick,
}) => (
  <div className={classnames('app', { 'internal-page': internalPage })}>
    <Navigation sections={sections} onNavLinkClick={onNavLinkClick} />
    {children}
    <Footer />
  </div>
);

PageLayout.propTypes = propTypes;
PageLayout.defaultProps = defaultProps;

export default PageLayout;



// WEBPACK FOOTER //
// ./src/components/PageLayout/index.js